var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/submissions/components/SubmissionForm/SubmissionFormCategory.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionFormCategory.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"SubmissionFormCategory\">\n        <h3 class=\"SubmissionFormElement-header\">Project Category</h3>\n        <ul class=\"SubmissionFormCategory-list\">\n            ";
frame = frame.push();
var t_8 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"categoriesList");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("item", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "<li class=\"SubmissionFormCategory-listItem\">\n                    <label for=\"SubmissionFormCategory-listItemRadio-";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
t_5 += "\">\n                        <input type=\"radio\" id=\"SubmissionFormCategory-listItemRadio-";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
t_5 += "\" name=\"category\" class=\"SubmissionFormCategory-listItemRadio\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"category") == runtime.memberLookup((t_9),"id")) {
t_5 += " checked";
;
}
t_5 += " value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"id"), env.opts.autoescape);
t_5 += "\">\n                        <div class=\"SubmissionFormCategory-listItemRadioIcon\"></div>\n                        <div class=\"SubmissionFormCategory-listItemTitle ";
if(runtime.memberLookup((t_9),"new")) {
t_5 += "SubmissionFormCategory-listItemTitle--short";
;
}
t_5 += "\" >";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"title"), env.opts.autoescape);
t_5 += "</div>\n                        <div class=\"SubmissionFormCategory-listItemCategory\">";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"category"), env.opts.autoescape);
t_5 += "</div>\n                        ";
if(runtime.memberLookup((t_9),"new")) {
t_5 += "\n                            <div class=\"SubmissionFormCategory-listItemLabel\">new</div>\n                        ";
;
}
t_5 += "\n                        <div class=\"SubmissionFormCategory-listItemSelectedFrame\"></div>\n                    </label>\n                </li>\n            ";
;
}
}
frame = frame.pop();
t_5 += "\n        </ul>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("SubmissionFormCategory");
context.setVariable("SubmissionFormCategory", macro_t_4);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/submissions/components/SubmissionForm/SubmissionFormCategory.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormCategory.jinja
// module id = 51
// module chunks = 0